import { type OpenApiSchemaDiscount } from '#shared/api/schema';
import { type PromoactionCollectionFields, type PromoactionModel } from '../types';

export const mapPromoactionToDiscount = (
    promoaction: PromoactionModel
): OpenApiSchemaDiscount & Partial<PromoactionCollectionFields> => {
    const { discount, validity, applicability } = promoaction;

    const isPercent = discount.type === 'percent';

    return {
        id: promoaction.id,
        kind: promoaction.kind,
        ...(promoaction.promoOfferId ? { promo_offer_id: promoaction.promoOfferId } : {}),
        created_at: promoaction.meta.createdAt,
        updated_at: promoaction.meta.updatedAt,
        title: promoaction.title,
        discount_value: {
            value: isPercent ? discount.value_percent : discount.value_fixed,
            type: isPercent ? 'PERCENT' : 'VALUE',
        },
        discount_applicability: applicability.type === 'ALL_PRODUCTS' ? 'ALL_PRODUCTS' : 'SELECTED_PRODUCTS',
        discount_objects: {
            category_ids:
                applicability.type === 'CATEGORIES_AND_COLLECTIONS' ? applicability.appliedCategoryIds : undefined,
            collection_ids:
                applicability.type === 'CATEGORIES_AND_COLLECTIONS' ? applicability.appliedCollectionIds : undefined,
            productListID:
                applicability.type === 'PRODUCT_LIST' ? applicability.appliedProductListId || undefined : undefined,
        },
        discount_dates: {
            start_date: validity.validFrom,
            end_date: validity.validUntil === '' ? undefined : validity.validUntil,
        },
        is_active: !promoaction.meta.deactivated,
        is_currently_active: promoaction.meta.status === 'active',
        ...(promoaction.kind === 'REGULAR' && promoaction.mode.mode === 'automatic'
            ? {
                  show_auto_collection_in_feed: promoaction.showAutoCollectionInFeed,
                  collection_title: promoaction.autoCollectionTitle,
                  collection_description: promoaction.autoCollectionDescription,
              }
            : {}),
    };
};
